import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlSnrAuthFieldsFragment = { id: string, filingYear: string, filingNumber: string, serialNumber: string, registrationDate: string, companyId: string, createdAt: string, updatedAt: string, noBoardStatement: boolean, auths: Array<{ kind: string, date: string, before: string, before_year?: string | null }> };

export const SnrAuthFieldsFragmentDoc = gql`
    fragment SnrAuthFields on SnrAuthorization {
  id
  filingYear
  filingNumber
  serialNumber
  registrationDate
  auths {
    kind
    date
    before
    before_year
  }
  companyId
  createdAt
  updatedAt
  noBoardStatement
}
    `;